import TokenService from "./token.service";
import instance from "./instanceapi";
import axios from "axios";
import {refreshTokenURL} from "./api";
import {logout, refreshToken} from "../components/auth/actions/authAction";


// an interceptor can be understood as a filter of http requests and responses before they are actually sent or received.
const setup = (store) => {
    //When the client send a request
    instance.interceptors.request.use(
        (config) => {
            const token = TokenService.getToken()
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token
            }
            return config
        },
        (error) => {
            return Promise.reject(error)
        }
    )

    const {dispatch} = store
    let isRefreshing = false;
    //when we receive a response from the server
    instance.interceptors.response.use(
        (res) => {
            //if it's authorized
            return res
        },
        async (err) => {
            const originalConfig = err.config
            //if we are requesting on a url that is everything except login and if we receive an error from the response
            if (originalConfig.url !== "login" && err.response) {
                // we ant to handle 401 status so we check the status' response
                if (err.response.status === 401 && !originalConfig._retry) {
                    // we user an flag call _retry on original request to handle infinite loop (in the case that request is failed again and the server continue to return 401 status code).
                    originalConfig._retry = true
                    if (!isRefreshing) {
                        isRefreshing = true;
                        try {
                            const actualRefreshToken = {
                                refreshToken: TokenService.getLocalRefreshToken()
                            }
                            const rs = await axios.post(refreshTokenURL(), actualRefreshToken)
                            const accessToken = rs.data.refreshToken
                            const token = rs.data.token
                            dispatch(refreshToken(token, accessToken))
                            TokenService.updateLocalRefreshToken(accessToken)
                            TokenService.updateLocalAccessToken(token)
                            isRefreshing = false
                            return instance(originalConfig)
                        } catch (_error) {
                            isRefreshing = false
                            dispatch(logout())
                            return Promise.reject(_error)
                        }
                    }
                }
            }
            return Promise.reject(err);
        }
    )
}

export default setup;